import styled from "styled-components";
import Rectangle from "../../images/Rectangle.svg";
import Company from "../../images/Company.svg";

export const MainDiv = styled.div`
  display: flex;
  width: 100%;
  height: 100vh; /* Ensure the container takes the full height of the viewport */

  .left_container {
    width: 50%;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
    
    div {
      width: 400px;
      height: 211px;
      display: flex;
      gap:35px;
      flex-direction: column;

      .head{
        width:400px;
        height:40px;
        font-weight: 700;
        font-size:20px;
        top:279px;

      }

      .head1 {
        width: auto;
        height: 11px;
        font-size: 16px;
        font-weight: 700;
        line-height: 20.66px;
        color: #1e2228;
        top:349px;

      }
      .head2 {
        width:400px;
        height: auto;
        color: #1e2228;
      }
      & button{
         display: flex;
        height:40px;
        width:121px;
        padding: 10px 20px;
        font-size: 16px;
        font-weight: 700;
        background-color:#ff2c91;

        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        justify-content:center;
        align-items:center
      }
    }
  }

  .right_container {
    width: 50%;
    background-image: url(${Rectangle});
    background-size: cover;
    background-position: center;

    display: flex;
    justify-content: center;
    align-items: center;

    div {
      background-image: url(${Company});
      background-size: contain;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 488.1px;
      height: 269px;
    }
  }
`;